import { isNil } from 'lodash';
import { createSelector } from 'reselect';
import { numericSorter } from '../../../utils/utils';
import { getBanksWithLapsedState } from '../existingBanks/existingBanks.selectors';
import { getLastFour } from '../../../utils/banking/bank-utils';
/**
 * Simple selector to extract cartLookup selected bank object from the sell transaction.
 * @param state
 * @returns {Bank|null} Currently selected bank
 */
export const getEverifyFailures = (state) => state.eVerification.failureHistory;

/**
 * Complex selector to extract the agreement map corresponding to the selected bank. or a 'default' agreement map
 * with empty lookups if no bank is selected.
 * @param state
 * @returns {AgreementMapEx}
 */
export const getEverifyFailureCount = createSelector(
  getEverifyFailures,
  (everifyFailures) => (everifyFailures ? everifyFailures.length : 0)
);

export const getLastEverifyFailure = createSelector(
  getEverifyFailures,
  (everifyFailures) => {
    if (isNil(everifyFailures)) {
      return [];
    }
    return [...everifyFailures].sort(numericSorter)[0];
  }
);

export const getManualBankRoutingNumber = (state) =>
  state.eVerification.manualBankRoutingNumber;

export const getManualBankAccountNumber = (state) =>
  state.eVerification.manualBankAccountNumber;

export const getManualBankAccountType = (state) =>
  state.eVerification.manualBankAccountType;

export const getIsEnteredBankLapsed = createSelector(
  getBanksWithLapsedState,
  getManualBankRoutingNumber,
  getManualBankAccountNumber,
  getManualBankAccountType,
  (
    banksWithLapsedState,
    manualBankRoutingNumber,
    manualBankAccountNumber,
    manualBankAccountType
  ) => {
    return banksWithLapsedState.some(
      (bank) =>
        bank.routingNumber === manualBankRoutingNumber &&
        bank.bankAccountType === manualBankAccountType &&
        getLastFour(bank.accountNumber) === getLastFour(manualBankAccountNumber)
    );
  }
);
